import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useDeleteTransaction({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({ transaction }: { transaction: object }) => {
    if (transaction.transaction_type === 'Transfer') {
      return await httpClient.delete(
          `/team/cash-flow/transfers/${transaction.id}`
      )
    }
    return await httpClient.delete(
        `/team/cash-flow/transactions/${transaction.id}`
    )
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: async (res, variables) => {
      await queryClient.invalidateQueries({ queryKey: ['transactions'] })
      toast.success('Transaction deleted')
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
